// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupplierModal_overlay__lFknS {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.SupplierModal_modal__jchR2 {
  text-align: center;
  width: 420px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
}

.SupplierModal_header__UaPDu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SupplierModal_closeBtn__vkZEk {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.SupplierModal_tabButtons__00Wbw {
  display: flex;
  gap: 12px;
  margin: 15px 0;
}

.SupplierModal_activeTab__aHaha {
  padding: 8px 15px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #333;
  border-radius: 7px;
}

.SupplierModal_inactiveTab__vYY6u {
  padding: 8px 15px;
  background: #f2f2f2;
  border-radius: 7px;
  border: 1px solid #ccc;
}

.SupplierModal_search__w8iDQ {
  width: 100%;
  padding: 9px 12px;
  border-radius: 7px;
  border: 1px solid #ccc;
  margin-bottom: 15px;
}

.SupplierModal_list__srHpe {
  max-height: 280px;
  overflow-y: auto;
}

.SupplierModal_listItem__jcyTK {
  width: 100%;
  background: #f7f7f7;
  border-radius: 7px;
  padding: 10px;
  border: none;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}

.SupplierModal_pagination__AxaZ1 {
  display: flex;
  gap: 6px;
  justify-content: center;
  margin: 15px 0;
}

.SupplierModal_pagination__AxaZ1 button {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
}

.SupplierModal_activePage__lbQ-W {
  background: rgba(29, 135, 82, 1);
  color: rgba(29, 135, 82, 1);
  border: 1px solid rgba(29, 135, 82, 1) !important;
}

.SupplierModal_selectButton__hqkfl {
  padding: 12px 50px;
  background: #333;
  color: white;
  border-radius: 10px;
  border: none;
  margin-top: 10px ;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/SupplierModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.modal {\n  text-align: center;\n  width: 420px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.tabButtons {\n  display: flex;\n  gap: 12px;\n  margin: 15px 0;\n}\n\n.activeTab {\n  padding: 8px 15px;\n  font-weight: 600;\n  background: #fff;\n  border: 1px solid #333;\n  border-radius: 7px;\n}\n\n.inactiveTab {\n  padding: 8px 15px;\n  background: #f2f2f2;\n  border-radius: 7px;\n  border: 1px solid #ccc;\n}\n\n.search {\n  width: 100%;\n  padding: 9px 12px;\n  border-radius: 7px;\n  border: 1px solid #ccc;\n  margin-bottom: 15px;\n}\n\n.list {\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.listItem {\n  width: 100%;\n  background: #f7f7f7;\n  border-radius: 7px;\n  padding: 10px;\n  border: none;\n  margin-bottom: 10px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.pagination {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  margin: 15px 0;\n}\n\n.pagination button {\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  background: #fff;\n}\n\n.activePage {\n  background: rgba(29, 135, 82, 1);\n  color: rgba(29, 135, 82, 1);\n  border: 1px solid rgba(29, 135, 82, 1) !important;\n}\n\n.selectButton {\n  padding: 12px 50px;\n  background: #333;\n  color: white;\n  border-radius: 10px;\n  border: none;\n  margin-top: 10px ;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `SupplierModal_overlay__lFknS`,
	"modal": `SupplierModal_modal__jchR2`,
	"header": `SupplierModal_header__UaPDu`,
	"closeBtn": `SupplierModal_closeBtn__vkZEk`,
	"tabButtons": `SupplierModal_tabButtons__00Wbw`,
	"activeTab": `SupplierModal_activeTab__aHaha`,
	"inactiveTab": `SupplierModal_inactiveTab__vYY6u`,
	"search": `SupplierModal_search__w8iDQ`,
	"list": `SupplierModal_list__srHpe`,
	"listItem": `SupplierModal_listItem__jcyTK`,
	"pagination": `SupplierModal_pagination__AxaZ1`,
	"activePage": `SupplierModal_activePage__lbQ-W`,
	"selectButton": `SupplierModal_selectButton__hqkfl`
};
export default ___CSS_LOADER_EXPORT___;
